import { createContext, useContext, useEffect, useState, useMemo, useCallback } from "react";

const CartCtx = createContext();

const LS_KEY = "wmm_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { localStorage.setItem(LS_KEY, JSON.stringify(items)); } catch {}
  }, [items]);

  const addItem = useCallback((product, size) => {
    setItems(prev => {
      const idx = prev.findIndex(i => i.product_id === product.id && i.size === size);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: Math.min(20, next[idx].quantity + 1) };
        return next;
      }
      return [...prev, {
        product_id: product.id,
        size,
        quantity: 1,
        name: product.name,
        price: product.price,
        image: product.image,
      }];
    });
    setOpen(true);
  }, []);

  const removeItem = useCallback((product_id, size) => {
    setItems(prev => prev.filter(i => !(i.product_id === product_id && i.size === size)));
  }, []);

  const updateQty = useCallback((product_id, size, quantity) => {
    setItems(prev => prev.map(i =>
      i.product_id === product_id && i.size === size
        ? { ...i, quantity: Math.max(1, Math.min(20, quantity)) }
        : i
    ));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const count = useMemo(() => items.reduce((s, i) => s + i.quantity, 0), [items]);
  const subtotal = useMemo(() => items.reduce((s, i) => s + i.quantity * i.price, 0), [items]);

  return (
    <CartCtx.Provider value={{ items, addItem, removeItem, updateQty, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartCtx.Provider>
  );
}

export function useCart() { return useContext(CartCtx); }
